import React from 'react';
import _HotLine from './_HotLine.scss';

class HotLine extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <div className="top-hot-line">
        <p className='hot-line-content'><span className='content-red'>Tổng đài:&nbsp;</span>1900 8003</p>
      </div>
    );
  }
}

export default HotLine;


// WEBPACK FOOTER //
// ./components/layouts/master/sub-header/HotLine.jsx